import className from 'classnames';
import React from 'react';

const ToggleBox = ({ checked, value, onChange, label, small }) => {
  return <div
    className={className('toggle-box flex-center', { checked, small, unclickable: !onChange })}
    onClick={() => {
      if (onChange) {
        onChange(value)
      }
    }}>
    {label}
  </div>
}

export default ToggleBox


// WEBPACK FOOTER //
// ./src/containers/components/toggle-box.js